import React from 'react'
import { PropTypes } from 'prop-types'
import { ProgressSpinner } from '@jsluna/react'

const Loading = props => (
  <div className="[ ln-c-card--soft ]">
    <div className="ln-o-flag">
      <div className="ln-o-flag__component">
        <div className="ln-c-loading-indicator">
          <ProgressSpinner />
        </div>
      </div>
      <div className="ln-o-flag__body ln-u-push-left-sm">
        {props.title ? props.title : 'Loading' }
      </div>
    </div>
  </div>
)

Loading.propTypes = {
  title: PropTypes.string
}

Loading.defaultProps = {
  title: 'Loading'
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading/index.jsx